/**
 * @file src/components/organisms/TrendingYieldBearingAssets/TrendingYieldBearingAssetsCardHeader.tsx
 * @description This file defines the header component for the TrendingYieldBearingAssetsCard card.
 * The header includes the title and a "See All" button, which navigates to the full list of yield-bearing assets.
 * @module TrendingYieldBearingAssetsCardHeader
 */

import { FC } from 'react';
import { useRouter } from 'next/router';
import { Button, Card, Text } from '@/components';
import { LABELS } from '@/utils/strings';
import { URLS } from '@/utils/constants';
import { useYieldBearingAssets } from '@/components/providers/postauth/YieldBearingAssetsProvider';

const TrendingYieldBearingAssetsCardHeader: FC = () => {
  const router = useRouter();
  const { loading } = useYieldBearingAssets();

  const handleSeeAllYieldBearingAssets = () => {
    router.push(URLS.allYieldBearingAssets);
  };

  return (
    <Card.Header
      title={`${LABELS.TRENDING_YIELD_BEARING_ASSETS_CARD.CARD_HEADER.TITLE}`}
      rightNodeElements={[
        <Button
          intent="ghost"
          key="see_all_yield_bearing_assets_button"
          onClick={handleSeeAllYieldBearingAssets}
        >
          {LABELS.TRENDING_YIELD_BEARING_ASSETS_CARD.CARD_HEADER.SEE_ALL_BUTTON}
        </Button>,
      ]}
      loading={loading}
    />
  );
};

export default TrendingYieldBearingAssetsCardHeader;
